import React from 'react';
import { Sparkles } from 'lucide-react';
import { useSubscriptionNavigation } from '../../hooks/subscriptions/useSubscriptionNavigation';

interface UpgradeButtonProps {
  className?: string;
  children?: React.ReactNode;
}

export function UpgradeButton({ className = '', children }: UpgradeButtonProps) {
  const { navigateToSubscription } = useSubscriptionNavigation();

  return (
    <button
      onClick={navigateToSubscription}
      className={`inline-flex items-center px-6 py-2.5 text-xs font-bold text-black bg-[#d8f477] rounded-full hover:opacity-90 transition-all ${className}`}
    >
      <Sparkles className="h-3.5 w-3.5 mr-1.5" />
      {children || 'Upgrade Plan'}
    </button>
  );
}